import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

import CarrierBondTypeSelectField from "./CarrierBondTypeSelectField";
import CarrierDialogStandardActions from "./CarrierDialogStandardActions";

export default function CarrierLimitDialogs({ vm }) {
  const {
    setIsEditLimitDialogOpen,
    handleCloseLimitDialog,
    limitAuthorityLimit,
    setLimitAuthorityLimit,
    setLimitEffectiveDate,
    editLimitDetails,
    setEditLimitDetails,
    limitEffectiveDate,
    handleUpdateLimit,
    isEditLimitDialogOpen,
    handleAddLimits,
    openLimitDialog,
    limitBondType,
    bondsList,
    setLimitBondType,
    isSubmitting,
  } = vm;

  return (
    <>
      <Dialog open={openLimitDialog} onClose={handleCloseLimitDialog}>
        <DialogTitle>Add New Limit</DialogTitle>
        <DialogContent sx={{ width: "400px" }}>
          <CarrierBondTypeSelectField
            bondsList={bondsList}
            value={limitBondType}
            onChange={(e) => setLimitBondType(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Authority Limit"
            type="number"
            fullWidth
            variant="outlined"
            value={limitAuthorityLimit}
            onChange={(e) => setLimitAuthorityLimit(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Effective Date"
            type="date"
            fullWidth
            variant="outlined"
            value={limitEffectiveDate}
            onChange={(e) => setLimitEffectiveDate(e.target.value)}
            slotProps={{ inputLabel: {
              shrink: true,
            }}}
          />
        </DialogContent>
        <CarrierDialogStandardActions
          onCancel={handleCloseLimitDialog}
          onSubmit={handleAddLimits}
          submitting={isSubmitting}
          submitLabel="Add Limit"
        />
      </Dialog>

      <Dialog open={isEditLimitDialogOpen} onClose={() => setIsEditLimitDialogOpen(false)}>
        <DialogTitle>Edit Limit</DialogTitle>
        <DialogContent sx={{ width: "400px" }}>
          <CarrierBondTypeSelectField
            bondsList={bondsList}
            value={editLimitDetails.bond_type}
            onChange={(e) => setEditLimitDetails({ ...editLimitDetails, bond_type: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Authority Limit"
            type="number"
            fullWidth
            variant="outlined"
            value={editLimitDetails.bond_amount}
            onChange={(e) => setEditLimitDetails({ ...editLimitDetails, bond_amount: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Effective Date"
            type="date"
            fullWidth
            variant="outlined"
            value={editLimitDetails.effective_date}
            onChange={(e) => setEditLimitDetails({ ...editLimitDetails, effective_date: e.target.value })}
            slotProps={{ inputLabel: {
              shrink: true,
            }}}
          />
        </DialogContent>
        <CarrierDialogStandardActions
          onCancel={() => setIsEditLimitDialogOpen(false)}
          onSubmit={handleUpdateLimit}
          submitting={isSubmitting}
          submitLabel="Save"
        />
      </Dialog>
    </>
  );
}

CarrierLimitDialogs.propTypes = {
  vm: PropTypes.object.isRequired,
};
